import { useState, useEffect } from "react";
import { buscarIndicacaoParceiro } from "../../../services/buscarIndicacaoParceiroService";
import { formatPhoneNumber } from "../../../uteis/formatPhoneNumber";

export const useBuscarIndicacoesParceiros = () => {
  const [indicacoesParceiros, setIndicacoesParceiros] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const buscar = async () => {
    setIsLoading(true);
    const data = await buscarIndicacaoParceiro();

    const indicacoesFormatadas = data.map((item: any) => ({
      id: item.id || "",
      nomeParceiro: item.Parceiro?.nome || "",
      descricao: item.Parceiro?.descricao || "",
      nomeLeads: item.Leads?.nome || "",
      celular: formatPhoneNumber(item.Leads?.celular) || "",
      status: item.status || "",
      active: item.active,
    }));

    setIndicacoesParceiros(indicacoesFormatadas);
    setIsLoading(false);
  };

  useEffect(() => {
    buscar();
  }, []);

  return { indicacoesParceiros, isLoading, buscar };
};
